import React from 'react';
import TrainingItem from './TrainingItem';

const TrainingList = ({ filteredResults, filters, resultSort }) => {
  return (
    <div className="training-page">
      <section className="training-container">
        <ul>
          {filteredResults.map((trainingPage, index) => (
            <TrainingItem
              key={index}
              trainingPage={trainingPage}
              filters={filters}
              resultSort={resultSort}
            />
          ))}
        </ul>
      </section>
    </div>
  );
};

export default TrainingList;
